import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface Tab {
  key: string;
  label: ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
}

export function Tabs({ tabs, active, onChange, className }: TabsProps) {
  return (
    <div className={cn('rounded-lg border border-border/60 bg-card p-1', className)}>
      <div className="flex gap-1 overflow-x-auto pb-0.5 no-scrollbar sm:flex-wrap">
        {tabs.map((t) => {
          const isActive = t.key === active;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => onChange(t.key)}
              className={cn(
                'shrink-0 rounded-md px-3 py-1 text-sm font-medium transition-colors touch-manipulation min-h-[30px]',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-muted/40 hover:text-foreground',
              )}
            >
              {t.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
